export default __webpack_public_path__ + "static/media/3.63643dd4.svg";